import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);



        this.group = this.el.closest( '.group.step' );
        this.checkboxes = [...this.group.querySelectorAll( '[name="' + this.el.dataset.checked + '"]' )];

        this.checkboxes.forEach( checkbox => checkbox.addEventListener( 'click', this.hasChecked.bind( this ) ) );
        this.el.addEventListener( 'click', e => {
            if( ! this.group.classList.contains( 'invalid' ) ){
                this.el.closest( '[data-steps]').className = this.el.dataset.class;
                this.call( 'update', false, 'Scroll' );
            }
        });


    }
    hasChecked(){
        this.group.classList.toggle( 'invalid', ! this.group.querySelectorAll( '[name="' + this.el.dataset.checked + '"]:checked' ) );

    }
    init() {}
    destroy(){}
}
